export default __webpack_public_path__ + "static/media/defaultBanner.29882cfd.png";